<template>
  <div id="contactInformation">
    <v-form v-model="form.contactInformation" ref="formEdit">
      <v-container>
        <v-layout wrap class="pr-4 pl-4">
          <v-flex xs12 class="button-container pr-0 text-xs-right">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex :class="{'subheading' : $vuetify.breakpoint.mdAndUp}" class="pr-4 ml-4 pf-text-default">
            <p>{{ topContent }}</p>
          </v-flex>
        </v-layout>
        <v-layout wrap class="pb-4 pt-3">
          <v-flex class="xs12 sm6">
            <v-text-field 
              label="Street Address Line 1" 
              v-model.trim="contactDetails.line_1"
              class="pr-4 pl-4" 
              @input="changedData">
            </v-text-field>
            <v-text-field 
              label="Street Address Line 2" 
              v-model="contactDetails.line_2" 
              @input="changedData" 
              class="pr-4 pl-4">
            </v-text-field>
            <v-layout wrap>
              <v-flex class="xs12 sm6 full">
                <v-text-field 
                  label="Zip Code" 
                  v-model="contactDetails.zip" 
                  class="pr-4 pl-4"
                  :rules="[rules.zipRules]"
                  @input="changedData($event,'zip')"> 
                </v-text-field>
                <v-autocomplete
                  label="State" 
                  :items="filteredData" 
                  item-value="id"
                  item-text="name"
                  :no-data-text="alertMessage"
                  class="pr-4 pl-4"  
                  :readonly="contactDetails.country && contactDetails.country.name === 'United States'"
                  @change="changedData($event, 'State')" 
                  v-model="contactDetails.state">
                </v-autocomplete>
            </v-flex>  
            <v-flex class="xs12 sm6">
                <v-autocomplete
                  label="Country" 
                  class="pr-4 pl-4"
                  item-text="name"
                  item-value="id"
                  :items="Country" 
                  v-model="contactDetails.country" 
                  @change="changedData($event, 'Country')">
                </v-autocomplete>
                <v-autocomplete
                  v-if="contactDetails.country === '5f0af2eb1b61360afbb1aa0c'"
                  label="City"
                  :items="cityData"
                  class="pr-4 pl-4" 
                  :readonly="cityData.length === 1"
                  @change="changedData"
                  v-model="contactDetails.city"
                  ></v-autocomplete>
                  <v-text-field 
                  v-else
                  label="City" 
                  class="pr-4 pl-4" 
                  v-model.trim="contactDetails.city"
                  @input="changedData">
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-text-field 
              label="Email Address" 
              v-model="contactDetails.email" 
              @blur="duplicateEmailChecking"
              class="required pr-4 pl-4"
              :rules="[rules.required, rules.emailRules]"
              v-validate="'required'" 
              data-vv-name="emailAddress" 
              @input="changedData">
            </v-text-field>
            <v-text-field 
              v-mask="'(###) ###-####'"
              label="Phone Number" 
              v-model="contactDetails.phone" 
              @input="changedData" 
              :rules="[rules.phoneRules]"
              class="pr-4 pl-4">
            </v-text-field>
            <v-text-field
              label="Website URL"
              hint="Ex: https://example.com, http://example.com"
              v-model="contactDetails.website"
              class="pr-4 pl-4"
              :rules="rules.websiteRules"
              data-vv-name="websiteAddress"
              @input="changedData">
            </v-text-field>
            <v-checkbox 
              v-model="contactDetails.is_default" 
              label="Set as Default Contact" 
              @change="changedData" 
              class="pr-4 pl-4">
            </v-checkbox>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex wrap class="pr-4 ml-4 pf-text-default">
            <p>{{ bottomContent }}</p>
          </v-flex>
        </v-layout>
        <v-layout wrap class="pr-4 pl-4">
          <v-flex xs12 class="button-container pr-0 text-xs-right">
            <div class="d-inline-flex" v-if="selectedData">
              <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons">
                <v-icon size="16" class="pr-1">cancel</v-icon>
                <div>Cancel</div>
              </v-btn>
              <v-btn class="pf-btn pf-btn-save" @click="save">
                <v-icon size="16" class="pr-1">check_circle</v-icon>
                <div>Save</div>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
/* global session store */
import { mask } from 'vue-the-mask';
import { mapGetters } from 'vuex';
import { getOne, update, getCollection, validateUrl, request } from '../helpers/helpers';
import swal from 'sweetalert2';
import VeeValidate from 'vee-validate';
import Vue from 'vue';
Vue.use(VeeValidate);
export default {
  name: 'contactInformation',
  directives: { mask },
  props: {

  },
  data: (vm) => ({
    entity: 'Account',
    alertMessage: '',
    accountDetails: {},
    contactDetails: {
      line_2: '',
      country: 'United States',
      country_text: '',
      phone: '',
      is_default: false,
      line_1: '',
      city: '',
      state: '',
      state_text: '',
      zip: '',
      email: '',
      website: ''
    },
    cityData: [],
    form: {
      contactInformation: '',
    },
    topContent: `All your  information is PRIVATE and not shared with anyone. 
                 This information is ONLY used by ParentFinder staff to contact you.`,
    bottomContent: 'By checking this box your email address and phone number listed above will be displayed for contact on public pages. Validate this with your agency or attorney prior to selecting.',
    emailAddress: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    zipcode: '',
    phoneNumber: '',
    checkbox: '',
    state: ['Arizona', 'California', 'Florida', 'Michigan', 'Texas', 'Washington'],
    rules: {
      required: value => !!value || 'Field is required.',
      blankRules: (v) => !!v && v.trim().length > 0 || 'Field is required',
      emailRules: (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/.test(v) || 'Please enter valid email address',
      zipRules: (v) => v === undefined || v === '' || /^([0-9]{5}|[0-9]{6})(?:-[0-9]{4})?$/.test(v) || 'Please enter valid zip code',
      phoneRules: (v) => v === undefined || v === '' || /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/.test(v) || 'Please enter valid phone number',
      websiteRules: [
        (v) => v === undefined || v === '' || (validateUrl(v)) || 'Please enter valid URL',
        v => !v || vm.checkIfNoPFUrl(v) || 'The entered URL is not valid for campaigns'
      ]
    },
    countryModel: '',
    selectedData: false,
  }),
  computed: {
    ...mapGetters([]),
    
    filteredData () {
      let countryId = typeof this.contactDetails.country === 'object' ? this.contactDetails.country.id : this.contactDetails.country;
      this.alertMessage = countryId ? 'No data available' : 'Please select country before state';
      let options = this.State;
      return options.filter(o => o.country.id === countryId);
    },
    session () {
      return this.store.state.session;
    },
    Account: {
      get () {
        return store.state.Account;
      },
      set (value) {
        store.commit('setAccount', value);
      }
    },
    Child: {
      get () {
        return store.state.Child;
      },
      set (value) {
        store.commit('setChild', value);
      }
    },
    Country: {
      get () {
        return store.state.Country;
      },
      set (value) {
        store.commit('setCountry', value);
      }
    }, 
    State: {
      get () {
        return store.state.State;
      },
      set (value) {
        store.commit('setState', value);
      }
    }    
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    this.entity = session.role() === 'child' ? 'Child' : this.entity;
    this.accountDetails = JSON.parse(JSON.stringify(this[this.entity]));
    this.contactDetails = { ...this.accountDetails.contactInfo } || {};
    if (this.contactDetails.city) {
      this.cityData.push(this.contactDetails.city);
    }
    this.initializeCountry();
    this.initializeState();
  },
  methods: {
    checkIfNoPFUrl (url) {
      if (url) {
        return url.indexOf('/profile/') === -1/*  && url.split('/').length <= 3 */;
      }
      return false;
    },
    async initializeCountry () {
      if (!this.Country.length) {
        let sort = { name: 1 };
        let { error, data } = await getCollection('Country', true, 0, '', {}, null, null, sort);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.Country = data;
          }
        }
      }
    },
    async initializeState () {
      if (!this.State.length) {
        let sort = { name: 1 };
        let { error, data } = await getCollection('State', true, 0, '', {}, null, null, sort);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.State = data;
          }
        }
      }
    },
    async save () {
      if (this.$refs.formEdit.validate()) {
        this.selectedData = false;
        if (this.contactDetails.state === '') {
          delete this.contactDetails.state;
          delete this.contactDetails.state_text;
        }
        this.accountDetails.contactInfo = this.contactDetails;
        this.accountDetails.updated_from = 'contactInfo';
        let updateId = session.getSession().adminUser ? session.getSession().user.human[this.entity.toLowerCase()].id : 'Me';
        let { error, data, status } = await update(this.entity, this.accountDetails, updateId);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
        } else {
          this.loading = false;
          this[this.entity] = data;
          swal.fire({
            type: 'success',
            title: 'Contact information updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.selectedData = false;
            }
          });
        }
      }
    },
    async duplicateEmailChecking () {
      let where = { 'contactInfo.email': this.contactDetails.email };
      let { error, data } = await getCollection(this.entity, true, 0, '', where);
      if (error) {
        console.log(error);
      } else {
        if (data.length > 0 && this[this.entity].id !== data[0].id) {
          swal.fire({
            title: 'The entered email address already exists',
            type: 'error',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Close',
          }).then((result) => {
            if (result.value) {
              this.contactDetails.email = '';
            }
          });
        }
      }
    },
    async changedData (event, changedList = 'None') {
      if (changedList === 'Country') this.contactDetails.state = '';
      if (changedList === 'Country' && event) {
        let countryName = this.Country.find(country => country.id === event);
        this.contactDetails.country_text = countryName.name;
      } else if (changedList === 'State' && event) {
        let stateName = this.filteredData.find(state => state.id === event);
        this.contactDetails.state_text = stateName.name;
      }
      else if (changedList === 'zip' && this.contactDetails.zip.length >= 5)
      {
        let payload = {
          'zipcode': this.contactDetails.zip
        };
        let { error, data } = await request('AddressLookup', 'POST', payload);
        if (error)
        {
          swal.fire({
            type: 'error',
            title: 'Invalid Address',
            timer: 2500,
          });
        }
        else
        {
          this.cityData.push(data.city);
          this.contactDetails.city = this.cityData[0];
          this.contactDetails.country = '5f0af2eb1b61360afbb1aa0c';
          let stateName = this.filteredData.find(state => state.code === data.state);
          this.contactDetails.state = stateName;
          this.contactDetails.state_text = stateName.name;
          this.contactDetails.country_text = 'United States';
        }
      }
      this.selectedData = true;
    },
    hideButtons () {
      this.selectedData = false;
      this.accountDetails = JSON.parse(JSON.stringify(this[this.entity]));
      this.contactDetails = { ...this.accountDetails.contactInfo } || {};
      this.$refs.formEdit.resetValidation();
    },
  },

};
</script>

<style lang="css" scoped>
#contactInformation >>> .v-icon.material-icons.accent--text {
  color: #019d8c !important;
  caret-color:  #019d8c !important;
}

</style>



// WEBPACK FOOTER //
// src/pages/ContactInformation.vue